import { Component } from '@angular/core';
import { CovidService } from './covid.service';
import { SwUpdate } from '@angular/service-worker';
import { MatSnackBar } from '@angular/material/snack-bar';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.less']
})
export class AppComponent {
  active = null;
  wuhan: {};
  constructor(private service: CovidService,
              private updates: SwUpdate,
              private toast: MatSnackBar) {

    this.updates.available.subscribe(event => {
      const message = 'There is a new version available';
      const action = 'Update';
      const update = this.toast.open(message, action, {
        duration: 18000,
        verticalPosition: 'bottom'
      });
      update
      .onAction()
      .subscribe(() => {
        window.location.reload();
      });
    });

    this.service.getData().subscribe(data => {
      this.wuhan = data;
    });
  }
  tabChanged($event) {
    this.active = $event.index;
  }
}
